(function () {
  if (window.StoreSwitcherTabsLoaded) return;
  window.StoreSwitcherTabsLoaded = true;

  function activate(section, index) {
    const tabs = section.querySelectorAll('[data-store-tab]');
    const panels = section.querySelectorAll('[data-store-panel]');
    const images = section.querySelectorAll('[data-store-image]');

    tabs.forEach((tab) => {
      const active = Number(tab.dataset.storeTab) === index;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    panels.forEach((panel) => {
      const active = Number(panel.dataset.storeIndex) === index;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });

    images.forEach((image) => {
      const active = Number(image.dataset.storeIndex) === index;
      image.classList.toggle('is-active', active);
      image.hidden = !active;
    });
  }

  function init(section) {
    if (!section || section.dataset.storeSwitcherReady === 'true') return;
    section.dataset.storeSwitcherReady = 'true';

    const tabs = section.querySelectorAll('[data-store-tab]');
    if (!tabs.length) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        activate(section, Number(this.dataset.storeTab));
      });
    });

    const firstActive = section.querySelector('[data-store-tab].is-active');
    activate(section, firstActive ? Number(firstActive.dataset.storeTab) : 0);
  }

  function initAll(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-store-switcher]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    const panel = event.target.closest('[data-store-panel]');
    if (!panel) return;

    const section = panel.closest('[data-store-switcher]');
    if (!section) return;

    init(section);
    activate(section, Number(panel.dataset.storeIndex));
  });
})();